import { FlexColumn, FlexRow, LabeledData, useMoment } from '@gorila-shared-ui/components';
import { StyledDivider } from 'baseui/divider';
import { LabelXSmall } from 'baseui/typography';
import { useStyles } from '../../../hooks/useStyles';
import { IntegrationLog } from '../../../types/integrations';
import { isDevice } from '../../../utils/currentStates';
import { StyledCard } from '../../shared/styledCard/StyledCard';

type Props = {
  log: IntegrationLog;
};

function IntegrationLogDetail({ log }: Readonly<Props>) {
  const { formatDateFromTs } = useMoment();
  const { theme, css } = useStyles();

  return (
    <StyledCard>
      <FlexColumn gap={0}>
        <FlexColumn
          gap={theme.sizing.scale100}
          classNames={css({ padding: `${theme.sizing.scale300} ${theme.sizing.scale600}` })}
        >
          <LabeledData
            labelWidth="60px"
            label="Etiqueta:"
            content={log.asset.label}
          />
          <LabeledData
            labelWidth="60px"
            label="Ident:"
            content={isDevice(log.asset.device) ? log.asset.device.ident : '-'}
          />
        </FlexColumn>
        <StyledDivider
          $size="cell"
          style={{ marginTop: 0, marginBottom: 0, width: '100%' }}
        />
        <FlexRow
          classNames={css({
            padding: `${theme.sizing.scale300} ${theme.sizing.scale600}`,
          })}
        >
          <LabelXSmall color={theme.colors.contentTertiary}>{formatDateFromTs(+log.created)}</LabelXSmall>
        </FlexRow>
      </FlexColumn>
    </StyledCard>
  );
}

export default IntegrationLogDetail;
